import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from '../error_boundary_v1';
import PrUsersIndex from './index/pr_users_index';

function TopLevelIndex({ view }) {
  return (
    <ErrorBoundary>
      <PrUsersIndex view={view} />
    </ErrorBoundary>
  );
}

TopLevelIndex.propTypes = {
  view: PropTypes.string,
};

TopLevelIndex.defaultProps = {
  view: 'all',
};

export default TopLevelIndex;
